import React from 'react'
import { cn } from '@/lib/utils'

interface CheckboxFieldProps {
  label: string
  description?: string
  checked: boolean
  onChange: (checked: boolean) => void
  activeBadge?: string
  className?: string
}

export const CheckboxField: React.FC<CheckboxFieldProps> = ({
  label,
  description,
  checked,
  onChange,
  activeBadge,
  className = '',
}) => {
  return (
    <label
      className={cn(
        'flex items-start gap-3 cursor-pointer select-none rounded-lg border p-4 transition-colors',
        checked
          ? 'bg-accent/5 border-accent/30'
          : 'bg-card border-border hover:bg-surface',
        className,
      )}
    >
      {/* Custom checkbox */}
      <div className="mt-0.5 flex-shrink-0">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="sr-only"
        />
        <div
          className={cn(
            'h-4 w-4 rounded border-2 flex items-center justify-center transition-all',
            checked ? 'bg-accent border-accent' : 'bg-card border-border',
          )}
        >
          {checked && (
            <svg className="h-2.5 w-2.5 text-white" fill="none" viewBox="0 0 12 12">
              <path
                d="M2 6l3 3 5-5"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm font-semibold text-foreground">{label}</span>
          {checked && activeBadge && (
            <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide bg-accent text-white">
              {activeBadge}
            </span>
          )}
        </div>
        {description && (
          <p className="text-xs text-muted-foreground mt-1 leading-relaxed">{description}</p>
        )}
      </div>
    </label>
  )
}
